// services/notificationService/query.ts - services/notificationService.ts split (sub-module query)

import { supabase, getSessionUser } from '../../supabase';
import { mapRowToNotification } from './map';


/**
 * Fetch notifications for user from database with AbortController support
 */
export async function getNotifications(options: { limit?: number; offset?: number } = {}) {
  const { limit = 50, offset = 0 } = options;

  try {
    const user = await getSessionUser();
    if (!user) return [];

    // Add AbortController for cancellation support
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000); // 30s timeout

    const { data, error } = await supabase
      .from('notifications')
      .select('*', { count: 'exact', head: false })
      .eq('user_id', user.id)
      .eq('is_deleted', false)
      .order('created_at', { ascending: false })
      .range(offset, offset + limit - 1)
      .throwOnError();

    clearTimeout(timeoutId);

    if (error) throw error;
    return (data || []).map(mapRowToNotification);
  } catch (err: any) {
    // Don't throw on abort/cancel errors
    if (err.name === 'AbortError' || err.message?.includes('abort') || err.message?.includes('canceled')) {
      return [];
    }
    throw err;
  }
}



// Get unread count with proper abort handling
export async function getUnreadCount() {
  try {
    const user = await getSessionUser();
    if (!user) return 0;

    // Add AbortController for cancellation support
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000);

    const { count, error } = await supabase
      .from('notifications')
      .select('*', { count: 'exact', head: true })
      .eq('user_id', user.id)
      .eq('is_deleted', false)
      .eq('is_read', false)
      .throwOnError();

    clearTimeout(timeoutId);

    if (error) throw error;
    return count || 0;
  } catch (err: any) {
    // Don't throw on abort/cancel errors
    if (err.name === 'AbortError' || err.message?.includes('abort') || err.message?.includes('canceled')) {
      return 0;
    }
    return 0;
  }
}
